import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import {BsModalService} from "ngx-bootstrap/modal";
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-send-request-actions',
  templateUrl: './send-request-actions.component.pug',
  styleUrls: ['./send-request-actions.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SendRequestActionsComponent implements OnInit, OnChanges {
  @Input() submitLabel = $localize`Submit`;
  @Input() messages: any[] = [];
  @Input() org: any;
  @Input() disableSend = true;
  @Input() total = 0;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSubmit = new EventEmitter();
  errorMessage: any[] = [];
  noPermissionToSend = false;
  warningMessage: any[] = [];
  attachToFooter = false;
  @Input() isReceipentUptoLimit = false
  @Input() isScheduleDateTimeInPast = false
  constructor(private modalService: BsModalService,
              private permissions: PermissionsService,
              public ngZone: NgZone) {
  }

  ngOnInit(): void {
    const canSendReferenceRequest = this.permissions.hasPermission('can_send_reference_requests') || this.permissions.hasPermission('can_send_reference_requests_with_survey_perms');
    const canSendPulseRequest = this.permissions.hasPermission('can_send_pulse_requests') || this.permissions.hasPermission('can_send_pulse_requests_with_survey_perms');
    const canSendExitRequest = this.permissions.hasPermission('can_send_exit_requests') || this.permissions.hasPermission('can_send_exit_requests_with_survey_perms');
    const canSendBackgroundRequest = this.permissions.hasPermission('can_send_backgroundcheck_requests');

    // Button will be disabled if user doesn't have any of the following permissions
    this.noPermissionToSend = !(canSendReferenceRequest || canSendPulseRequest || canSendExitRequest || canSendBackgroundRequest);


  }

  @HostListener('window:scroll', ['$event']) onWindowScroll(e) {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      //At bottom of page
      this.ngZone.run(() => {
        this.attachToFooter = true
      })
    } else if ((window.innerHeight + window.scrollY) < (document.body.offsetHeight - 100)) {
      // No longer at bottom of page
      this.ngZone.run(() => {
        this.attachToFooter = false
      })
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.messages.length > 0) {
      if (this.messages.findIndex(message => message['type'] === 'danger') == -1) this.errorMessage = [];
      this.messages.forEach(val => {
        if (val['type'] === 'danger') {
          this.errorMessage.push(val);
        }
        if (val['type'] === 'warning') {
          if (this.warningMessage.findIndex(message => message['key'] === val['key']) == -1) {
            this.warningMessage.push(val);
          }
        }
      })
    } else {
      this.errorMessage = [];
      this.warningMessage = [];
    }
  }

  submit() {
    this.messages = [];
    this.errorMessage = [];
    this.warningMessage = [];
    this.onSubmit.emit('submit');
  }

  cancel() {
    this.messages = [];
    this.onSubmit.emit('clear');
    this.permissions.setNavCheck(true);
  }

}
